import StandaloneReferenceViewerCaseLawPage from '@/standalone-reference-viewer/caselaw/views/StandaloneReferenceViewerCaseLawPage'
import StandaloneReferenceViewerLegacyFilePage from '@/standalone-reference-viewer/legacy-file/views/StandaloneReferenceViewerLegacyFilePage'
import StandaloneReferenceViewerLrrPage from '@/standalone-reference-viewer/lrr/views/StandaloneReferenceViewerLrrPage'
import StandaloneReferenceViewerUserFilePage from '@/standalone-reference-viewer/user-file/views/StandaloneReferenceViewerUserFilePage'
import StandaloneReferenceViewerWritingSamplePage from '@/standalone-reference-viewer/writing-sample/views/StandaloneReferenceViewerWritingSamplePage'
import { kRouteSegments } from '@/routing/paths'
import type { RouteFactory } from '@/routing/types'

/**
 * Creates matter-scoped standalone reference viewer routes for nesting under MatterLayout.
 * These routes display referenced content (caselaw, LRR) outside of the chat context.
 * Matter context is encoded in the URL so it is retained when opening a reference in a new tab.
 *
 * URL patterns:
 * - /dashboard/m/:matterId/reference-viewer/caselaw/:idType?/:id
 * - /dashboard/m/:matterId/reference-viewer/lrr/:s3Path
 * - /dashboard/m/:matterId/reference-viewer/user-file/:referenceId
 * - /dashboard/m/:matterId/reference-viewer/writing-sample/:referenceId
 * - /dashboard/m/:matterId/reference-viewer/legacy-file?viewFile=:relativePath
 *
 * @see MatterLayout for parent route context
 */
export const createReferenceViewerChildRoutes: RouteFactory = () => [
  {
    path: `${kRouteSegments.referenceViewer}/caselaw/:idType?/:id`,
    element: <StandaloneReferenceViewerCaseLawPage />,
  },
  {
    path: `${kRouteSegments.referenceViewer}/lrr/:s3Path`,
    element: <StandaloneReferenceViewerLrrPage />,
  },
  {
    path: `${kRouteSegments.referenceViewer}/user-file/:referenceId`,
    element: <StandaloneReferenceViewerUserFilePage />,
  },
  {
    path: `${kRouteSegments.referenceViewer}/writing-sample/:referenceId`,
    element: <StandaloneReferenceViewerWritingSamplePage />,
  },
  {
    path: `${kRouteSegments.referenceViewer}/legacy-file`,
    element: <StandaloneReferenceViewerLegacyFilePage />,
  },
]
